<script>
    export default {
      name: 'widget-body',
      props: {
        'no-padding': {
          type: Boolean,
          default: false
        }
      },
      data () {
        return {}
      },
      computed: {},
      mounted () {
      },
      destroyed () {
      },
      methods: {},
      components: {}
    }
</script>

<template>
    <div class="widget-body" :class="{'no-padding': noPadding}">
        <slot/>
    </div>
</template>
